// extracted by mini-css-extract-plugin
module.exports = {"root":"petSimpleCard_root__1eIV9","wrap":"petSimpleCard_wrap__GSob9","info":"petSimpleCard_info__3Hrzp","name":"petSimpleCard_name__26Ygy","text":"petSimpleCard_text__3G44R"};